import { render } from "./AddForm.vue?vue&type=template&id=8e1ff476"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Data\\Bibliothèque\\Téléchargements\\public\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__